import { render } from "./Button.vue?vue&type=template&id=7b8d104e"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=7b8d104e&lang=scss"
script.render = render

export default script